module.exports = __webpack_public_path__ + "static/media/seguros-mundial-survey-thumbs-up.d482efd1.svg";